import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RootState from '../../core/root-state'
import { kiosksActions } from '../../core/kiosks'
import { strings } from '../components/kiosks/kiosks-content'
import styles from '../styles/modules/kiosks/kiosks.module.scss'
import KiosksTable from '../components/kiosks/kiosks-table'
import Layout from '../layouts/layout'
import Wrapper from '../layouts/wrapper'
import { modalActions } from '../../core/modal'
import Button from '../components/button'
import { ALLOWED_ACCESS_ONLY_FOR_ADMIN, Permission } from '../../core/auth0'
import withPermissionCheck from '../../core/access-control/with-permission-check'

const KiosksScreen = () => {
  const dispatch = useDispatch()
  const kiosks = useSelector((state: RootState) => state.kiosks.kiosks)
  const role = useSelector((state: RootState) => state.auth0.role)

  const handleOnClickOpenModal = () => {
    dispatch(modalActions.showCreateKiosk())
  }

  useEffect(() => {
    const fetchKiosks = () => {
      dispatch(kiosksActions.fetchKiosks())
    }

    fetchKiosks()
  }, [dispatch])

  return (
    <Layout location="kiosks">
      <Wrapper title={strings.title}>
        <Button
          disabled={!ALLOWED_ACCESS_ONLY_FOR_ADMIN.includes(role)}
          title={strings.createKioskButton}
          onClick={handleOnClickOpenModal}
          className={styles.kioskCreateButton}
        />
        <KiosksTable kiosks={kiosks} />
      </Wrapper>
    </Layout>
  )
}

export default withPermissionCheck(KiosksScreen, {
  requiredPermission: Permission.KIOSK_READ,
  redirectTo: '/404'
})
